<div class="loader-wrap">
  <span class="loader"></span>
</div>

